export const toasts = state => state.toasts;
